export default function mobNav() {
    let navMenuBtn = document.querySelector('.js-open-menu');
    let navMenu = document.querySelector('.nav-menu');

    navMenuBtn.addEventListener('click', () => {
        document.body.classList.toggle('nav-menu-open');
    })
}